module.exports = __webpack_public_path__ + "static/media/INDIGO_F1.c55b14b8.txt";